import { produce } from "immer";

import { createAsyncThunk } from "@src/store";
import {
  getProductPickerProducts,
  getProductPickerSelectedProducts,
  setProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";
import { getProductPickerProductMap } from "@src/store/slices/productPicker/selectors/getProductPickerProductMap";
import { getProductPickerSelectedProductMap } from "@src/store/slices/productPicker/selectors/getProductPickerSelectedProductMap";
import { getProductPickerSelectionType } from "@src/store/slices/productPicker/selectors/getProductPickerSelectionType";

export const toggleSelectAll = createAsyncThunk<void, void>(
  "productPicker/toggleSelectAll",
  (_, { dispatch, getState }) => {
    const selectionType = getProductPickerSelectionType(getState());
    const selectedProducts = getProductPickerSelectedProducts(getState());
    if (selectionType === "none" || selectionType === "partial") {
      const selectedProductMap = getProductPickerSelectedProductMap(getState());
      const products = getProductPickerProducts(getState());
      const result = produce(selectedProducts, (draft) => {
        for (const product of products) {
          if (selectedProductMap[product.id] === undefined) {
            draft.push(product);
          }
        }
      });
      dispatch(setProductPickerSelectedProducts(result));
    } else {
      const productMap = getProductPickerProductMap(getState());
      const result = selectedProducts.filter(
        (p) => productMap[p.id] === undefined
      );
      dispatch(setProductPickerSelectedProducts(result));
    }
  }
);
